import { render, staticRenderFns } from "./SpaceHorizontalProperty.vue?vue&type=template&id=ec1785ee&"
import script from "./SpaceHorizontalProperty.vue?vue&type=script&lang=js&"
export * from "./SpaceHorizontalProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports